import AnalysisIllustration from '@/components/illustrations/AnalysisIllustration.svg?react';
import BalanceSheetIllustration from '@/components/illustrations/BalanceSheetIllustration.svg?react';
import EntityOverviewIllustration from '@/components/illustrations/EntityOverviewIllustration.svg?react';
import HouseholdIllustration from '@/components/illustrations/HouseholdIllustration.svg?react';
import SummarizeDocsIllustration from '@/components/illustrations/SummarizeDocsIllustration.svg?react';
import { CLIENT_ONBOARDING_DESCRIPTIONS } from '@/modules/clientOnboarding/constants';

import {
  ClientOnboardingDeliverableConfig,
  ClientOnboardingDeliverableVariant,
} from '../types';

export const DELIVERABLE_SIDEBAR_CONFIG: Record<
  ClientOnboardingDeliverableVariant,
  ClientOnboardingDeliverableConfig
> = {
  [ClientOnboardingDeliverableVariant.SUMMARIZE_DOCUMENT]: {
    title: 'Create document summaries',
    description: CLIENT_ONBOARDING_DESCRIPTIONS.SUMMARIZE_DOCUMENTS,
    illustration: <SummarizeDocsIllustration />,
  },
  [ClientOnboardingDeliverableVariant.CREATE_ENTITY_OVERVIEW]: {
    title: 'Create entity overviews',
    description: CLIENT_ONBOARDING_DESCRIPTIONS.CREATE_ENTITY_OVERVIEW,
    illustration: <EntityOverviewIllustration />,
    calloutText:
      'To create multiple entity overviews, upload multiple documents',
  },
  [ClientOnboardingDeliverableVariant.BUILD_OUT_HOUSEHOLD]: {
    title: 'Build full client profile',
    description: CLIENT_ONBOARDING_DESCRIPTIONS.BUILD_OUT_HOUSEHOLD,
    illustration: <HouseholdIllustration />,
  },
  [ClientOnboardingDeliverableVariant.CREATE_ANALYSIS]: {
    title: 'Model a single strategy',
    description: CLIENT_ONBOARDING_DESCRIPTIONS.CREATE_ANALYSIS,
    illustration: <AnalysisIllustration />,
    calloutText:
      'Single strategy modeling is best for prospects or clients who want high-level projections. Use the hypothetical waterfall feature for more holistic scenario modeling based on the full financial profile.',
  },
  [ClientOnboardingDeliverableVariant.CREATE_BALANCE_SHEET]: {
    title: 'Create a balance sheet',
    description: CLIENT_ONBOARDING_DESCRIPTIONS.CREATE_BALANCE_SHEET,
    illustration: <BalanceSheetIllustration />,
  },
  [ClientOnboardingDeliverableVariant.GENERATE_ESTATE_SNAPSHOT]: {
    title: 'Create Estate360 presentation',
    description: CLIENT_ONBOARDING_DESCRIPTIONS.GENERATE_ESTATE_SNAPSHOT,
    illustration: <HouseholdIllustration />,
  },
};
